import { get } from '../utils/axios'

export const getReportNewAPI = async (param) => {
  return await get('report/new', param)
}

export const getReportResignAPI = async (param) => {
  return await get('report/resign', param)
}

export const getReportAppointAPI = async (param) => {
  return await get('report/appoint', param)
}

export const getReportBirthdayAPI = async (param) => {
  return await get('report/birthday', param)
}

export const getReportLoanHomeAccAPI = async (param) => {
  return await get('report/loan/home/acc', param)
}
